import { Model } from '@danangelus/ngx-app-core';
import { Page } from './page.model';
import { PermissionGroup } from './permission-group.model';
import { SamlServiceProvider } from "./saml-provider.model"

/**
 * Class representing an application
 */
export class Application extends Model {

    id: string | undefined
    created: string | undefined
    lastModified: string | undefined
    name: string | undefined
    description: string | undefined
    title: string | undefined
    baseUrl: string | undefined
    expertCode: string | undefined
    displayOrder: string | undefined
    icon: string | undefined
    locked: boolean | undefined
    groups: PermissionGroup[] = []
    pages: Page[] = []
    loading = false
    useSaml: boolean | undefined
    samlServiceProvider: SamlServiceProvider | undefined

    constructor(application?: any) {
        super(application);

        if (application?.groups?.length > 0) {
            this.groups = application.groups.map((group: any) => new PermissionGroup(group.name, group.fullDn))
        }

        if (application?.pages?.length > 0) {
            this.pages = application.pages.map((page: any) => new Page(page))
        }

        if (application?.samlServiceProvider) {
            this.samlServiceProvider = new SamlServiceProvider(application.samlServiceProvider)
        }
    }
}
